import React from 'react';
import { CheckIcon } from 'containers/Series/components/icons/CheckIcon';
import { LockIcon } from './LockIcon';

export const CourseSeriesStatusIcon = ({ completed, disabled }) => {
  if (completed) {
    return <CheckIcon transparent />;
  }

  if (disabled) {
    return <LockIcon />;
  }

  return null;
};
